import axios from "axios";
import staticHeaders from "./staticHeaders.json";
import baseURL from './baseURL';

export default (file) => new Promise(resolve => {
    let formData = new FormData();

    formData.set("uploaded_file", file);

    axios({
      url:`${baseURL()}/index.php?action=save_image`,
      method: "POST",
      headers: {
        ...staticHeaders,
        "Content-Type": "application/json"
      },
      data: formData
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch(err => {
        resolve(false);
      });
  });
